import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=790457ee&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=ts"
export * from "./summary-table.vue?vue&type=script&lang=ts"
import style0 from "./summary-table.vue?vue&type=style&index=0&id=790457ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790457ee",
  null
  
)

export default component.exports